// ADR-109 — صفحه‌ی مشترک سشن: بسته به نقش کاربر جاری، UI کارمند یا پشتیبان را نشان می‌دهد.
import { useParams } from "react-router-dom"; // ASSUMPTION: مسیریابی پروژه
import { useRemoteAssistSession, useRevealVerificationCode } from "../api";
import { VerificationCodeDialog } from "../components/VerificationCodeDialog";
import { SupporterControlView } from "../components/SupporterControlView";

import { useAuthStore } from "@/auth/authStore";

export function RemoteAssistSessionPage() {
  const { sessionId } = useParams<{ sessionId: string }>();
  const { data: session } = useRemoteAssistSession(sessionId);
  const user = useAuthStore((s) => s.user);

  const currentUserRole = session && user && session.employee_user_id === user.id ? "employee" : "supporter";

  // ⚠️ ACTION REQUIRED: در پیاده‌سازی فعلی reveal-code فقط سمت
  // supporter/vendor_agent را با پرمیشن 'manage' باز می‌کند؛ دسترسی
  // سمت employee به مسیر جداگانه‌ای نیاز دارد که هنوز طراحی نشده —
  // این useRevealVerificationCode برای هر دو نقش صدا زده می‌شود و باید
  // قبل از merge با بک‌اند واقعی هماهنگ شود.
  if (!session) return <p className="p-4 text-sm text-neutral-500">در حال بارگذاری سشن...</p>;

  if (session.status === "accepted") {
    return <VerificationCodeGate sessionId={session.id} role={currentUserRole} />;
  }

  if (session.status === "active" && currentUserRole === "supporter") {
    return <SupporterControlView sessionId={session.id} />;
  }

  if (session.status === "active" && currentUserRole === "employee") {
    // The ActiveRemoteAssistOverlay will handle the employee's banner and capture logic globally.
    // We just return a message here if they happen to stay on this page.
    return <p className="p-4 text-sm text-neutral-500">سشن فعال است و پشتیبان در حال مشاهده می‌باشد. می‌توانید به صفحات دیگر بروید.</p>;
  }

  return <p className="p-4 text-sm text-neutral-500">وضعیت سشن: {session.status}</p>;
}

function VerificationCodeGate({ sessionId, role }: { sessionId: string; role: "employee" | "supporter" }) {
  const { data, isLoading, error } = useRevealVerificationCode(sessionId);

  // For supporter, they just enter the code. They don't need to fetch it (it would return 403 anyway).
  if (role === "supporter") {
    return (
      <div className="p-6">
        <VerificationCodeDialog sessionId={sessionId} role="supporter" />
      </div>
    );
  }

  // For employee, they must fetch and see the code.
  if (isLoading) return <p className="p-4 text-sm text-neutral-500">در حال دریافت کد...</p>;
  if (error || !data) return <p className="p-4 text-sm text-red-600">امکان دریافت کد تأیید وجود ندارد.</p>;

  return (
    <div className="p-6">
      <VerificationCodeDialog sessionId={sessionId} role="employee" displayedCode={data.verification_code} />
    </div>
  );
}
